var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import * as Raven from 'raven-js';
import { getScoreSystem } from '@crimp/lib-score-systems';
import { setScoreboardTeam, setScoreboardAthlete, setScoreboardAthleteScore, setScoreboardAthleteScoreRoute, } from '../reducers/actions';
import FlipMove from 'react-flip-move';
import ListTeamsItem from './ListTeamsItem';
import AlertScoresHidden from './AlertScoresHidden';
import AlertScoresFinalized from './AlertScoresFinalized';
import AlertScoresLoading from './AlertScoresLoading';
import AlertEmptyRoundPrompt from './AlertEmptyRoundPrompt';
import ContentExplanations from './ContentExplanations';
var selfStyles = require('./styles.scss');
var ListTeams = (function (_super) {
    __extends(ListTeams, _super);
    function ListTeams(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            athleteScoreRouteItemWidth: 0,
        };
        _this.handleChangeTeam = _this.handleChangeTeam.bind(_this);
        _this.handleChangeAthlete = _this.handleChangeAthlete.bind(_this);
        _this.handleChangeAthleteScore = _this.handleChangeAthleteScore.bind(_this);
        _this.handleChangeAthleteScoreRoute = _this.handleChangeAthleteScoreRoute.bind(_this);
        _this.handleClickAthleteItem = _this.handleClickAthleteItem.bind(_this);
        return _this;
    }
    ListTeams.prototype.componentDidMount = function () {
        this.componentWillReceiveProps(this.props);
    };
    ListTeams.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.athleteScoreRouteWrapper ||
            !this.props.routes) {
            return;
        }
        var numRoutes = this.props.routes.length;
        var containerWidth = this.athleteScoreRouteWrapper.offsetWidth;
        var athleteScoreItemsWidth = numRoutes * 50;
        if (containerWidth >= athleteScoreItemsWidth) {
            this.setState({ athleteScoreRouteItemWidth: 50 });
        }
        else {
            var numRows = Math.ceil(athleteScoreItemsWidth / containerWidth);
            var numCellPerRow = Math.ceil(numRoutes / numRows);
            var cellWidth = Math.floor(containerWidth / numCellPerRow);
            this.setState({
                athleteScoreRouteItemWidth: cellWidth,
            });
        }
    };
    ListTeams.prototype.handleChangeTeam = function (teamId) {
        this.props.dispatch(setScoreboardTeam(teamId));
    };
    ListTeams.prototype.handleChangeAthlete = function (athleteId) {
        this.props.dispatch(setScoreboardAthlete(athleteId));
    };
    ListTeams.prototype.handleChangeAthleteScore = function (scoreId) {
        this.props.dispatch(setScoreboardAthleteScore(scoreId));
    };
    ListTeams.prototype.handleChangeAthleteScoreRoute = function (athleteScoreRouteId) {
        this.props.dispatch(setScoreboardAthleteScoreRoute(athleteScoreRouteId));
    };
    ListTeams.prototype.handleClickAthleteItem = function (aS) {
        if (!aS) {
            this.handleChangeAthlete('');
            this.handleChangeAthleteScore('');
            return;
        }
        this.handleChangeAthlete(aS.athlete.id);
        if (aS.score) {
            this.handleChangeAthleteScore(aS.score.id);
            this.handleChangeTeam(aS.score.teamId || '');
        }
    };
    ListTeams.prototype.render = function () {
        var _this = this;
        if (!this.props.teamScoreJoins) {
            return React.createElement(AlertScoresLoading, null);
        }
        if (!this.props.round.isScoresVisible && !this.props.isPlatform) {
            return React.createElement(AlertScoresHidden, null);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(AlertScoresFinalized, { isScoresFinalized: this.props.round.isScoresFinalized }),
            React.createElement(ContentExplanations, { category: this.props.category, round: this.props.round }),
            !this.props.round.isScoresVisible &&
                React.createElement(AlertScoresHidden, null),
            React.createElement("div", { ref: function (element) { _this.athleteScoreRouteWrapper = element; }, className: selfStyles.listWrapper },
                this.props.teamScoreJoins.length === 0 &&
                    React.createElement(AlertEmptyRoundPrompt, null),
                this.props.teamScoreJoins.length > 0 &&
                    React.createElement(FlipMove, { duration: 400, delay: 0, easing: 'ease' }, this.props.teamScoreJoins.map(function (tS) { return (React.createElement(ListTeamsItem, { key: tS.score.id, isActive: tS.team.id === _this.props.scoreboard.teamId, isActiveAthlete: _this.props.scoreboard.athleteId, isPlatform: _this.props.isPlatform, rank: tS.rank ? tS.rank : -1, round: _this.props.round, team: tS.team, teamScore: tS.score, athletes: tS.athletes, athleteScoreRouteItemWidth: _this.state.athleteScoreRouteItemWidth, handleClickTeamItem: function () {
                            _this.handleChangeTeam(tS.team.id);
                            var athletes = tS.athletes.sort(function (a, b) { return (!!a.score && !!b.score)
                                ? a.score.bibNumber - b.score.bibNumber
                                : a.athlete.name.localeCompare(b.athlete.name); });
                            _this.handleClickAthleteItem(athletes[0]);
                        }, handleClickAthleteItem: _this.handleClickAthleteItem, handleChangeAthleteScoreRoute: _this.handleChangeAthleteScoreRoute })); })))));
    };
    return ListTeams;
}(React.Component));
var mapStateToProps = function (state) {
    var scoreboard = state.scoreboard;
    var workspaceEvent = state.workspaceEvent;
    var categoryId = scoreboard.categoryId;
    var roundId = scoreboard.roundId;
    var category = workspaceEvent.categories && workspaceEvent.categories.data.find(function (r) { return r.id === categoryId; });
    var round = workspaceEvent.rounds && workspaceEvent.rounds.data.find(function (r) { return r.id === roundId; });
    if (!category ||
        !round ||
        !categoryId ||
        !roundId ||
        !workspaceEvent.routes ||
        !workspaceEvent.teams ||
        !workspaceEvent.teamScores ||
        !workspaceEvent.athletes ||
        !workspaceEvent.athleteScores) {
        return {
            category: category,
            round: round,
            routes: undefined,
            teamScoreJoins: undefined,
            scoreboard: state.scoreboard,
        };
    }
    var routes = workspaceEvent.routes.data
        .filter(function (r) { return r.roundId === roundId; });
    var scoreSystem = getScoreSystem(round.scoreSystem, round, routes);
    var teams = workspaceEvent.teams.data
        .filter(function (t) { return t.categoryId === categoryId; });
    var teamScores = workspaceEvent.teamScores.data
        .filter(function (tS) { return tS.roundId === roundId; });
    var athletes = workspaceEvent.athletes.data
        .filter(function (a) { return a.categoryId === categoryId; });
    var athleteScores = workspaceEvent.athleteScores.data
        .filter(function (aS) { return aS.roundId === roundId; });
    var athleteScoreRoutes = workspaceEvent.athleteScoreRoutes
        ? workspaceEvent.athleteScoreRoutes.data.filter(function (s) { return s.roundId === roundId; })
        : [];
    var teamScoreJoins = teamScores.reduce(function (teamAccumulator, tS) {
        var team = teams.find(function (t) { return t.id === tS.teamId; });
        if (!team) {
            return teamAccumulator;
        }
        var teamAthletes = athletes.filter(function (a) { return a.teamId === tS.teamId; });
        var teamAthleteScores = athleteScores.filter(function (aS) { return aS.teamId === tS.teamId; });
        var teamScoreJoin = {
            team: team,
            score: tS,
            athletes: teamAthleteScores.reduce(function (athleteAccumulator, aS) {
                var athlete = teamAthletes.find(function (a) { return a.id === aS.athleteId; });
                if (!athlete) {
                    return athleteAccumulator;
                }
                athleteAccumulator.push({
                    athlete: athlete,
                    score: aS,
                    athleteScoreRoutes: athleteScoreRoutes
                        .filter(function (sr) { return sr.athleteId === athlete.id; })
                        .sort(function (a, b) { return a.index - b.index; }),
                });
                return athleteAccumulator;
            }, []),
        };
        teamScoreJoin.score.summated = scoreSystem.summateTeam(teamScoreJoin);
        teamAccumulator.push(teamScoreJoin);
        return teamAccumulator;
    }, []);
    try {
        scoreSystem.sort(teamScoreJoins);
    }
    catch (err) {
        Raven.captureException(err);
    }
    return {
        category: category,
        round: round,
        routes: routes,
        teamScoreJoins: teamScoreJoins,
        scoreboard: state.scoreboard,
    };
};
export default connect(mapStateToProps)(ListTeams);



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ListTeams.tsx
// module id = 642
// module chunks = 0